import { fetchApi } from '@/config/axiosSetting.ts';
import { ActionListQuery } from '@/modules/FileDetail/queries/actionList/actionListQuery.type';

export const actionListQueryFunction = (id: string): Promise<ActionListQuery> =>
  fetchApi.get(`/actions/${id}/actions_list/`);
